// src/container/especialidades/areaCard.tsx
import React from "react";
import "../../styles/areaCard.css";
import PsicoTcc from "../../img/especialidadesImagens/psetcc.webp";
import PsicoSistemica from "../../img/especialidadesImagens/psicoSistemica.webp";
import PsicoHuma from "../../img/especialidadesImagens/psicoHuma.webp";
import Fonoaudi from "../../img/especialidadesImagens/fono_page.webp";
import Nutricao from "../../img/especialidadesImagens/nutri_page_intro.webp";
import Fisio from "../../img/especialidadesImagens/fisio_page.webp";
import Psicopedagogia from "../../img/especialidadesImagens/psicopedagogia.webp";
import NeuroPediatra from "../../img/especialidadesImagens/neuro_pediatra.webp";
import NueroAdulto from "../../img/especialidadesImagens/neuro_adulto.webp"
import Psiquiatria from "../../img/especialidadesImagens/psiquiatria_page.webp";
import Terapeuta from "../../img/psiquiatria.png";
import PsicoTccPage from "../psicologiaTcc/PsicoTcc";
import Pedagoga from "../../img/especialidadesImagens/pedagoga.webp";
import TerapeutaCasais from "../../img/especialidadesImagens/terapeuta_casais.webp";

import { Link } from 'react-router-dom';

interface AreaCardProps {
  title: string;
  backgroundImage: string;
  route: string;// Novo campo para a descrição
}

const Card: React.FC<AreaCardProps> = ({ title, backgroundImage, route }) => {
  return (
    <Link to={route} className="area-card">
      <div
        className="card-image-especialidade"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        <div className="overlay-especialidade" />
        <div className="card-title-overlay">
          <h3>{title}</h3>
        </div>
      </div>
    </Link>
  );
};


const Cards: React.FC = () => {
  const especialidades: AreaCardProps[] = [
    {
      title: "Psicologia TCC",
      backgroundImage: PsicoTcc,
      route: "/especialidade/psicologiatcc"
    },
    {
      title: "Psicologia Sistêmica",
      backgroundImage: PsicoSistemica,
      route: "/especialidade/psicoSistemica"
    },
    {
      title: "Psicologia Humanista",
      backgroundImage: PsicoHuma,
      route: "/especialidade/psicoHumanista"
    },
    {
      title: "Fonoaudiologia",
      backgroundImage: Fonoaudi,
      route: "/especialidade/fonoaudiologia"
    },
    {
      title: "Nutrição",
      backgroundImage: Nutricao,
      route: "/especialidade/nutricao"
    },
    {
      title: "Fisioterapia",
      backgroundImage: Fisio,
      route: "/especialidade/fisioterapia"
    },
    {
      title: "Psicopedagogia",
      backgroundImage: Psicopedagogia,
      route: "/especialidade/psicopedagogia"
    },
    {
      title: "Neurologia Pediátrica",
      backgroundImage: NeuroPediatra,
      route: "/especialidade/neurologistaPediatra"
    },
    {
      title: "Neurologia Adultos",
      backgroundImage: NueroAdulto,
      route: "/especialidade/neurologistaAdultos"
    },
    {
      title: "Psiquiatria",
      backgroundImage: Psiquiatria,
      route: "/especialidade/psiquiatria"
    },
    {
      title: "Terapeuta de Casais",
      backgroundImage: TerapeutaCasais,
      route: "/especialidade/terapeutaCasais"
    },
    {
      title: "Pedagogia",
      backgroundImage: Pedagoga,
      route: "/especialidade/pedagogia"
    },
  ];

  return (
    <div className="container_background_cards">
      <div className="teste_zoom">
        <div className="card-grid">
          {especialidades.map((item, index) => (
            <Card
              key={index}
              title={item.title}
              backgroundImage={item.backgroundImage}
              route={item.route}// Passa a descrição para cada card
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Cards;